export const msalConfig = {
  auth: {
      clientId: process.env.REACT_APP_AUTH_CLIENT_ID!, // This is the ONLY mandatory field that you need to supply.
      authority: process.env.REACT_APP_AUTH_AUTHORITY!, // Defaults to "https://login.microsoftonline.com/common"
      redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI!, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
      postLogoutRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI!, // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
      cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
      loggerOptions: {
          loggerCallback: (level: any, message: any, containsPii: any) => {
              return;
          }
      }
  }
};

/**
* Scopes you add here will be prompted for user consent during sign-in.
* By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
* For more information about OIDC scopes, visit: 
* https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
*/
export const loginRequest = {
  scopes: [""]
};